<template>
    <section class="shadow-lg p-4 gap-1.5 bg-white rounded-lg w-80">
        <Handle type="target" :position="Position.Left" />
        <article class="flex items-center gap-2">
            <article class="bg-primary-950 rounded-md p-2 inline-block">
                <Icon icon="iconoir:message" class="text-xl text-white"/>
            </article>
            <input type="text" placeholder="Field Name" v-model="data.name" class="block font-bold text-sm w-full outline-none border p-2 rounded-lg"/>
        </article>
        
        <textarea type="text" placeholder="Description" v-model="data.value" rows="5" cols="40" class="block text-xs w-full outline-none p-2 border rounded-lg mt-2 text-gray-500"></textarea>

        <Handle type="source" :position="Position.Right" />
    </section>
</template>

<script setup>
import { computed } from "vue"
import { Icon } from "@iconify/vue"
import { Handle, Position, useNode } from "@vue-flow/core"

const node = useNode()

const data = computed({
  get: () => { 
    return node.node.data;
  },
  set: (value) => {
    node.node.data = value
  }
})

</script>